<template>
  <div class="login">
    <div class="login__header">
      <div class="login__header--title">
        <img src="@/assets/logo.png" alt="logo" width="15%" />
        <strong>商情資料查詢系統</strong>
      </div>
    </div>

    <div class="login__func" v-if="!loginHide">
      <div class="login__func--infoCard">
        <div class="flex align-center justify-center">
          <label style="color:black;font-weight:700">帳號：</label>
          <input type="text" v-model.trim="userInfo.username" placeholder="請輸入帳號" :disabled="loginHide" />
        </div>
        <div class="flex align-center justify-center">
          <label style="color:black;font-weight:700">密碼：</label>
          <input type="password" v-model.trim="userInfo.pd" placeholder="請輸入密碼" :disabled="loginHide" />
        </div>
        <button @click="loginDeptName()">登入</button>
      </div>
    </div>

    <div class="footer">
      <!-- V05301520 -->
      <!-- <p>Copyright © 2023 minds Corporation. V0411</p> -->
    </div>

    <!-- 公告對話框 -->
    <el-dialog title="最新公告" :visible.sync="announcementDialogVisible" :close-on-click-modal="false" :show-close="false" :width="isTablet() || isMobile() ? '90%' : '50%'" @opened="initAnnouncementScroll">
      <div class="announcement-container" ref="announcementContainer" @scroll="onAnnouncementScroll" style="max-height:60vh; overflow-y:auto;">
        <div v-if="announcements.length === 0" style="text-align: center; padding: 40px 20px;">
          <p>暫無公告</p>
        </div>
        <el-card v-for="(ann, index) in announcements" :key="index" style="margin-bottom: 15px;">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold; font-size: 16px;">{{ ann.Title }}</span>
          </div>
          <div style="white-space: pre-wrap; line-height: 1.6;">
            {{ ann.Content }}
          </div>
        </el-card>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="!announcementScrolledToBottom" @click="confirmAnnouncement" style="width: 100%;">
          我已知悉，進入系統
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { notify, handleError } from "../utils/notify";
import { isTablet as isTabletDevice } from "../utils/deviceHelper";

export default {
  data() {
    return {
      userInfo: {
        username: "",
        pd: "",
      },
      loginHide: true,
      sAuthCode: "",
      sDecode: "",
      tbbToken: "",

      loginInfo: [
        { LoginName: "DC1", UserID: "TBB001", UserName: "DC1", DeptID: "H15", DeptName: "資訊部", RoleName: "DC", ComName: "臺灣中小企業銀行" },
        { LoginName: "DO1", UserID: "TBB002", UserName: "DO1", DeptID: "H15", DeptName: "資訊部", RoleName: "DO", ComName: "臺灣中小企業銀行" },
        { LoginName: "APA1", UserID: "TBB003", UserName: "APA1", DeptID: "H77", DeptName: "資訊部", RoleName: "APA", ComName: "臺灣中小企業銀行" },
        { LoginName: "AP1", UserID: "TBB004", UserName: "AP1", DeptID: "H77", DeptName: "資訊部", RoleName: "AP", ComName: "臺灣中小企業銀行" },
        { LoginName: "UAO1", UserID: "USER905", UserName: "UAO1", DeptID: "020", DeptName: "仁愛", RoleName: "UAO", ComName: "臺灣中小企業銀行" },
        { LoginName: "UO1", UserID: "TBB006", UserName: "UO1", DeptID: "020", DeptName: "仁愛", RoleName: "UO", ComName: "臺灣中小企業銀行" },
        { LoginName: "UC1", UserID: "TBB007", UserName: "UC1", DeptID: "020", DeptName: "仁愛", RoleName: "UC", ComName: "臺灣中小企業銀行" },
        { LoginName: "UAO2", UserID: "TBB008", UserName: "UAO2", DeptID: "850", DeptName: "高雄", RoleName: "UAO", ComName: "臺灣中小企業銀行" },
        { LoginName: "UO2", UserID: "TBB009", UserName: "UO2", DeptID: "850", DeptName: "高雄", RoleName: "UO", ComName: "臺灣中小企業銀行" },
        { LoginName: "UC2", UserID: "TBB010", UserName: "UC2", DeptID: "850", DeptName: "高雄", RoleName: "UC", ComName: "臺灣中小企業銀行" },
        { LoginName: "HE1", UserID: "TBB011", UserName: "HE1", DeptID: "991", DeptName: "區營運處1", RoleName: "HE", ComName: "臺灣中小企業銀行" },
        { LoginName: "HC11", UserID: "TBB012", UserName: "HC11", DeptID: "991", DeptName: "區營運處1", RoleName: "HC1", ComName: "臺灣中小企業銀行" },
        { LoginName: "HE2", UserID: "TBB011", UserName: "HE2", DeptID: "996", DeptName: "區營運處2", RoleName: "HE", ComName: "臺灣中小企業銀行" },
        { LoginName: "HC12", UserID: "TBB012", UserName: "HC12", DeptID: "996", DeptName: "區營運處2", RoleName: "HC1", ComName: "臺灣中小企業銀行" },
        { LoginName: "HD1", UserID: "TBB013", UserName: "HD1", DeptID: "H77", DeptName: "企金", RoleName: "HD", ComName: "臺灣中小企業銀行" },
        { LoginName: "HC1", UserID: "TBB014", UserName: "HC1", DeptID: "H77", DeptName: "企金", RoleName: "HC", ComName: "臺灣中小企業銀行" },
        { LoginName: "HD2", UserID: "TBB015", UserName: "HD2", DeptID: "041", DeptName: "國際", RoleName: "HD", ComName: "臺灣中小企業銀行" },
        { LoginName: "HC2", UserID: "TBB016", UserName: "HC2", DeptID: "041", DeptName: "國際", RoleName: "HC", ComName: "臺灣中小企業銀行" },
        { LoginName: "HD3", UserID: "TBB017", UserName: "HD3", DeptID: "H07", DeptName: "業發", RoleName: "HD", ComName: "臺灣中小企業銀行" },
        { LoginName: "HC3", UserID: "TBB018", UserName: "HC3", DeptID: "H07", DeptName: "業發", RoleName: "HC", ComName: "臺灣中小企業銀行" },
      ],

      // 公告相關狀態
      announcementDialogVisible: false,
      announcements: [],
      announcementScrolledToBottom: false,
      pendingRoleName: "",
      pendingSourceLabel: "",
    };
  },
  methods: {
    getCurrentUserInfo() {
      const storeUserInfo = this.$store.state.userInfo;
      if (storeUserInfo && Object.keys(storeUserInfo).length > 0) {
        return storeUserInfo;
      }

      try {
        const userInfoStr = window.localStorage.getItem("userInfo");
        return userInfoStr ? JSON.parse(userInfoStr) : null;
      } catch (error) {
        console.error("读取localStorage userInfo 失败:", error);
        return null;
      }
    },

    /**
     * 根据给定的角色名称获取重定向路径
     */
    getPathByRole(roleName) {
      if (!roleName) {
        return "/Home";
      }

      const role = roleName.toUpperCase();
      console.log("getPathByRole - 角色:", role);

      if (role === "UC") {
        return "/appr-mgmt";
      } else if (role === "UAO") {
        return "/case-mgmt";
      } else {
        return "/Home";
      }
    },

    /**
     * 根据用户角色获取登入后的重定向路径
     * UC -> /appr-mgmt
     * UAO -> /case-mgmt
     * 其他 -> /Home
     */
    getRedirectPath() {
      const userInfo = this.getCurrentUserInfo();

      console.log("getRedirectPath - userInfo:", userInfo);

      if (!userInfo || !userInfo.RoleName) {
        console.warn("userInfo或RoleName不存在，跳转到/Home");
        return "/Home";
      }

      const roleName = userInfo.RoleName.toUpperCase();
      console.log("用户角色:", roleName);
      //alert(`登入成功！您的角色是 ${roleName}，即將跳轉到相應頁面。`);

      return this.getPathByRole(roleName);
    },

    getUserRole(userInfo) {
      if (!userInfo) {
        return "";
      }

      if (Array.isArray(userInfo.Role) && userInfo.Role.length > 0) {
        return userInfo.Role[0] || "";
      }

      return userInfo.RoleName || userInfo.Role || "";
    },

    getDesktopRedirectPath(roleName) {
      if (roleName) {
        return this.getPathByRole(roleName);
      }

      const userInfo = this.getCurrentUserInfo();
      return this.getPathByRole(this.getUserRole(userInfo));
    },

    async navigateAfterLogin(roleName, sourceLabel) {
      const desktopRedirectPath = this.getDesktopRedirectPath(roleName);
      const forceTablet = (process.env.VUE_APP_FORCE_TABLET || "").toLowerCase() === "true";
      console.log(`${sourceLabel} - forceTablet:`, forceTablet, "isTabletDevice():", isTabletDevice());
      if (forceTablet || isTabletDevice()) {
        await this.$alert("檢測到您使用平板電腦，系統將為您切換至行動版。建議使用橫向模式，以提供最佳操作體驗。", "裝置偵測", {
          confirmButtonText: "確認",
          type: "info",
        });
        console.log(`${sourceLabel}後，平板設備改導向行動版，forceTablet:`, forceTablet);
        this.$router.push("/m/ctm");
        return;
      }

      // 原來詢問用戶是否切換的邏輯已移除，直接根據設備類型進行導向
      // if (isTablet()) {
      //   try {
      //     await this.$confirm('檢測到您使用平板電腦，是否切換至行動版以獲得更好的使用體驗？', '裝置偵測', {
      //       confirmButtonText: '切換為行動版',
      //       cancelButtonText: '保持桌面版',
      //       type: 'info'
      //     });
      //     console.log(`${sourceLabel}後，用戶同意切換至行動版`);
      //     this.$router.push('/m/ctm');
      //     return;
      //   } catch (error) {
      //     console.log(`${sourceLabel}後，用戶保持桌面版，准备转向:`, desktopRedirectPath);
      //     this.$router.push(desktopRedirectPath);
      //     return;
      //   }
      // }

      console.log(`${sourceLabel}准备转向桌面版:`, desktopRedirectPath);
      this.$router.push(desktopRedirectPath);
    },

    async loginDeptName() {
      // 目前先暫時寫死, 使用者角色為UAO, 主管角色為UC
      let req = {};

      // 判斷若userInfo.username 及 userInfo.pd 為空, 則不進行登入
      if (!this.userInfo.username || !this.userInfo.pd) {
        notify({
          title: "錯誤",
          message: "請輸入帳號及密碼",
          type: "error",
        });
        return;
      }

      if (this.userInfo.username == "admin") {
        req = {
          UserID: "USER001",
          UserName: "張小哥",
          ComName: "臺灣中小企業銀行",
          DeptID: "H15",
          DeptName: "資訊部",
          RoleName: "admin",
        };
      }

      const username = this.userInfo.username;
      const loginUser = this.loginInfo.find((user) => user.LoginName === username);
      if (loginUser) {
        req = {
          UserID: loginUser.UserID,
          UserName: loginUser.UserName,
          ComName: loginUser.ComName,
          DeptID: loginUser.DeptID,
          DeptName: loginUser.DeptName,
          RoleName: loginUser.RoleName,
        };
      }

      if (this.userInfo.username == "HC11") {
        req = {
          LoginName: "HC11",
          UserID: "minds002",
          DeptID: "991",
          DeptName: "北一區",
          RoleName: "HC1",
          ComName: "OOO銀行",
        };
      }
      if (this.userInfo.username == "HC1") {
        req = {
          LoginName: "HC1",
          UserID: "minds001",
          DeptID: "H77",
          DeptName: "企金部",
          RoleName: "HC",
          ComName: "OOO銀行",
        };
      }
      if (this.userInfo.username == "UC1") {
        req = {
          LoginName: "UC1",
          UserID: "minds003",
          DeptID: "020",
          DeptName: "A分行",
          RoleName: "UC",
          ComName: "OOO銀行",
        };
      }

      if (this.userInfo.username == "UAO1") {
        req = {
          LoginName: "UAO1",
          UserID: "minds004",
          DeptID: "020",
          DeptName: "A分行",
          RoleName: "UAO",
          ComName: "OOO銀行",
        };
      }

      if (this.userInfo.username == "UAO11") {
        req = {
          LoginName: "UAO11",
          UserID: "minds005",
          DeptID: "020",
          DeptName: "A分行",
          RoleName: "UAO",
          ComName: "OOO銀行",
        };
      }

      if (this.userInfo.username == "UC2") {
        req = {
          LoginName: "UC2",
          UserID: "minds006",
          DeptID: "110",
          DeptName: "B分行",
          RoleName: "UC",
          ComName: "OOO銀行",
        };
      }

      if (this.userInfo.username == "UAO2") {
        req = {
          LoginName: "UAO2",
          UserID: "minds007",
          DeptID: "110",
          DeptName: "B分行",
          RoleName: "UAO",
          ComName: "OOO銀行",
        };
      }

      if (this.userInfo.username == "HC12") {
        req = {
          LoginName: "HC12",
          UserID: "minds008",
          DeptID: "996",
          DeptName: "南二區",
          RoleName: "HC1",
          ComName: "OOO銀行",
        };
      }

      this.$store.dispatch("loadingHandler", true);
      try {
        if (!req.UserID || !req.RoleName) {
          notify({
            title: "錯誤",
            message: "帳號無對應角色，請改用已配置帳號或聯絡管理員",
            type: "error",
          });
          return;
        }

        //console.log('LoginDept req:', req);
        req = {
          username: this.userInfo.username,
          password: this.userInfo.pd,
        };
        console.log("LoginDept req:", req);
        const res = await this.$store.dispatch("Login", req);

        console.log("LoginDept res:", res);
        if (res == "success") {
          notify({
            title: "成功",
            message: "登入成功!",
            type: "success",
          });
          console.log("登入成功，準備取得使用者所在的地區並導向頁面");
          // 取得登入使用者所在的地區
          await this.getBranchDist();
          this.navigateAfterLogin(req.RoleName, "部門登入");
        } else {
          notify({
            title: "錯誤",
            message: res && res.message ? res.message : "登入失敗，請稍後再試",
            type: "warning",
          });
        }
      } catch (err) {
        notify({
          title: "錯誤",
          message: err && err.data && err.data.message ? err.data.message : "網路發生錯誤",
          type: "error",
        });
        console.log(err);
      } finally {
        this.$store.dispatch("loadingHandler", false);
      }
    },

    async loginePortal(aCode) {
      let req1 = {
        AuthCode: aCode,
        ClientIP: "127.0.0.1",
      };

      // this.$store.dispatch("loadingHandler", true);

      //console.log("ePortal req1",req1);
      await this.$store
        .dispatch("LoginePortal", req1)
        .then((res) => {
          //console.log(res);
          if (res == "success") {
            notify({
              title: "成功",
              message: "登入成功!",
              type: "success",
            });
            this.navigateAfterLogin("", "SSO 登入");
          } else {
            notify({
              title: "錯誤",
              message: res && res.message ? res.message : "登入失敗，請稍後再試",
              type: "warning",
            });
          }
          this.$store.dispatch("loadingHandler", false);
        })
        .catch((err) => {
          notify({
            title: "錯誤",
            message: "網路發生錯誤",
            type: "error",
          });
          console.log(err);
        });

      // 取得登入使用者所在的地區
      await this.getBranchDist();
      this.$store.dispatch("loadingHandler", false);
    },

    // 取得登入使用者所在的地區
    async getBranchDist() {
      await this.$store.dispatch("InitBranchLocation", { force: true });
    },

    async login() {
      if (!!this.userInfo.username && !!this.userInfo.pd) {
        // const start = Date.now();
        this.$store.dispatch("loadingHandler", true);
        await this.$store
          .dispatch("Login", this.userInfo)
          .then((msg) => {
            if (msg == "success") {
              notify({
                title: "成功",
                message: "登入成功!",
                type: "success",
              });
              this.navigateAfterLogin("", "一般登入");
            } else {
              notify({
                title: "錯誤",
                message: msg,
                type: "warning",
              });
            }
            this.$store.dispatch("loadingHandler", false);
          })
          .catch((errMsg) => {
            notify({
              title: "帳密錯誤或無此帳號",
              message: "帳密錯誤或無此帳號",
              type: "error",
            });
            this.$store.dispatch("loadingHandler", false);
          });
        // const millis = Date.now() - start;
        // console.log(`登入頁載入時間 = ${Math.floor(millis / 1000 )}`);
      } else {
        notify({
          title: "錯誤",
          message: "請確實輸入帳號或密碼！",
          type: "error",
        });
      }
    },

    // NOTE: announcement fetching handled globally in App.vue per-login

    // 初始化公告滑動狀態
    initAnnouncementScroll() {
      if (this.$refs.announcementContainer) {
        this.$nextTick(() => {
          const container = this.$refs.announcementContainer;
          // 檢查是否已經在底部
          this.checkAnnouncementScroll(container);
        });
      }
    },

    // 檢測公告容器滑動
    onAnnouncementScroll(event) {
      const container = event.target;
      this.checkAnnouncementScroll(container);
    },

    // 檢查是否滑動到底部
    checkAnnouncementScroll(container) {
      if (!container) return;

      // 檢查滑動位置：底部位置 >= 容器高度 - 滾動高度 - 10px 容差
      const isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight <= 10;
      this.announcementScrolledToBottom = isAtBottom;
    },

    // 確認公告並進入系統
    confirmAnnouncement() {
      this.announcementDialogVisible = false;
      this.announcements = [];
      this.announcementScrolledToBottom = false;

      // 導向到指定頁面
      this.navigateAfterLogin(this.pendingRoleName, this.pendingSourceLabel);
    },

    isTablet() {
      return isTabletDevice();
    },

    isMobile() {
      return window.innerWidth < 768;
    },
  },
  async mounted() {
    this.sAuthCode = this.$route.query.authCode || this.$route.query.aCode;
    // console.log("sAuthCode",this.sAuthCode);
    let t1 = encodeURI(this.sAuthCode);
    // console.log("encodeURI_t1", t1);
    let t2 = encodeURIComponent(this.sAuthCode);

    let debugEnv = process.env.VUE_APP_BASE_DEBUG;
    console.log("debugEnv", debugEnv);
    // console.log("encodeURIComponent_t2", t2);
    //if ( this.sAuthCode  ) {
    // 當有authCode 時, 去呼叫TBB SSO
    if (this.sAuthCode) {
      this.$store.dispatch("loadingHandler", true);
      this.loginHide = true;
      //console.log("開始呼叫TBB ePortal");
      await this.loginePortal(t2);
      //console.log("結束TBB ePortal");
      this.$store.dispatch("loadingHandler", false);
    } else {
      if (debugEnv == "False" && !this.sAuthCode) this.loginHide = true;
      else this.loginHide = false;
    }

    //console.log("loginHide", this.loginHide);
  },
};
</script>

<style lang="scss" scoped>
// * {
//   outline: red 1px solid;
// }

// 公告對話框樣式
.announcement-container {
  max-height: 500px;
  overflow-y: auto;
  padding: 10px 0;

  .el-card {
    border: 1px solid #e8e8e8;
    border-radius: 4px;

    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}

.login {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  // background: linear-gradient(-45deg, transparent 55%, #191972 0) right,
  //   linear-gradient(45deg, transparent 15px, #00abb9 0) left;
  // background: linear-gradient(135deg,#E0652A 3%, #fff 50%, #FFF6EF ) center center / 100% 100%;
  background: linear-gradient(135deg, #191970 20%, #fff 50%, #fff6ef) center center / 100% 100%;

  @media (min-width: 1024px) {
    flex-direction: row;
  }

  &__header {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    &--title {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 5%;

      strong {
        font-size: 36px;
        letter-spacing: 5px;
        color: white;
        margin-left: 3%;
        padding: 0px 0px;
        text-shadow: black 0.1em 0.1em 0.2em;
      }
    }
  }

  &__func {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    @media (min-width: 450px) {
      align-items: center;
    }

    &--infoCard {
      width: 100%;
      display: flex;
      margin-top: 30%;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      div {
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;

        @media (min-width: 450px) {
          flex-direction: row;
        }

        label {
          min-width: 100px;
          max-width: 100px;
          font-size: 20px;
          color: white;
          letter-spacing: 10px;
        }

        input {
          width: 300px;
          border: none;
          padding: 8px;
          font-size: 16px;
          letter-spacing: 0.2rem;
        }
      }

      button {
        width: calc(100% - 20px);
        max-width: 400px;
        background: #191970;
        padding: 4px;
        border-radius: 8px;
        font-size: 20px;
        color: white;
        font-weight: bold;
        letter-spacing: 5px;
        transition: 0.6s;
        border: 1px solid white;
        cursor: pointer;

        &:hover {
          background: #dfdff5;
          border: 1px solid #191970;
          color: #191970;
        }
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 1rem;
    width: 100%;
    text-align: center;

    p {
      margin-bottom: 0;
      font-size: 18px;
      color: grey;
      letter-spacing: 2.5px;
    }
  }
}
</style>
